import React from "react";
import { Tab, TabList } from "@headlessui/react";
import { FaHistory, FaChartLine } from "react-icons/fa";
import { useTranslation } from "react-i18next";

/**
 * History Tab-Navigation Component
 * Reuses the design from statistics TabNavigation for consistency
 */

// Helper-Funktion für CSS-Klassen
const classNames = (...classes) => {
  return classes.filter(Boolean).join(" ");
};

const HistoryTabNavigation = ({
  selectedIndex,
  isMobileDropdownOpen,
  setIsMobileDropdownOpen,
  onTabChange,
}) => {
  const { t } = useTranslation();

  const tabs = [
    {
      name: t("history.tabs.totalHistory"),
      shortName: t("history.tabs.totalHistory"),
      icon: FaHistory,
      color: "text-test",
    },
    {
      name: t("history.tabs.currentRound"),
      shortName: t("history.tabs.currentRound"),
      icon: FaChartLine,
      color: "text-test",
    },
  ];

  return (
    <>
      {/* Mobile Horizontal Scrollable Tabs */}
      <div className="sm:hidden mb-3 -mt-4">
        <div className="relative">
          {/* Tab Container with horizontal scroll */}
          <div className="overflow-x-auto scrollbar-hide">
            <div className="flex space-x-2 px-4 py-2 min-w-max justify-center">
              {tabs.map((tab, index) => {
                const Icon = tab.icon;
                const isSelected = index === selectedIndex;

                return (
                  <button
                    key={tab.name}
                    onClick={() => onTabChange(index)}
                    className={`
                      flex-shrink-0 flex flex-col items-center justify-center
                      px-4 py-3 rounded-2xl transition-all duration-300 ease-out
                      min-w-[80px] relative overflow-hidden
                      ${
                        isSelected
                          ? "bg-gradient-to-br from-test to-test/90 text-primary shadow-lg scale-105"
                          : "bg-secondary/40 text-white/80 hover:bg-secondary/60 hover:text-white"
                      }
                    `}
                  >
                    {/* Background gradient for selected tab */}
                    {isSelected && (
                      <div className="absolute inset-0 bg-gradient-to-r from-test/10 to-transparent pointer-events-none" />
                    )}

                    {/* Icon */}
                    {/* <div className="relative z-10 mb-1">
                      <Icon
                        className={`
                        w-5 h-5 transition-colors duration-200
                        ${isSelected ? "text-primary" : tab.color}
                      `}
                      />
                    </div> */}

                    {/* Text */}
                    <span
                      className={`
                      text-xs font-medium text-center leading-tight relative z-10
                      ${isSelected ? "text-primary" : "text-white/90"}
                    `}
                    >
                      {tab.shortName}
                    </span>

                    {/* Active indicator */}
                    {isSelected && (
                      <div className="absolute bottom-1 left-1/2 transform -translate-x-1/2 w-1 h-1 bg-primary rounded-full" />
                    )}
                  </button>
                );
              })}
            </div>
          </div>

          {/* Scroll indicators */}
          <div className="absolute top-0 right-0 h-full w-8 bg-gradient-to-l from-primary via-primary/50 to-transparent pointer-events-none" />
          <div className="absolute top-0 left-0 h-full w-8 bg-gradient-to-r from-primary via-primary/50 to-transparent pointer-events-none" />
        </div>
      </div>

      {/* Enhanced Desktop Tabs */}
      <TabList
        className="
        hidden sm:flex w-full max-w-4xl mx-auto p-1 rounded-2xl mb-3 -mt-4
        bg-gradient-to-r from-secondary/50 to-secondary/40 
        backdrop-blur-md shadow-xl border border-primary/20
      "
      >
        {tabs.map((tab, index) => {
          const Icon = tab.icon;
          return (
            <Tab
              key={tab.name}
              className={({ selected }) =>
                classNames(
                  "flex items-center justify-center space-x-2 px-4 sm:px-6 py-3 sm:py-4 text-sm font-medium rounded-xl transition-all duration-300 ease-out w-full relative overflow-hidden",
                  selected
                    ? "bg-gradient-to-r from-test to-test/90 text-primary shadow-lg transform scale-[1.02]"
                    : "text-white/80 hover:bg-secondary/60 hover:text-white hover:scale-[1.01]",
                  "focus:outline-none focus:ring-2 focus:ring-test/50 focus:ring-offset-2 focus:ring-offset-transparent"
                )
              }
            >
              {({ selected }) => (
                <>
                  {/* <Icon
                    className={`w-4 h-4 ${
                      selected ? "text-primary" : tab.color
                    }`}
                  /> */}
                  <span className="hidden sm:inline">{tab.name}</span>
                  {selected && (
                    <div className="absolute inset-0 bg-gradient-to-r from-test/10 to-transparent pointer-events-none" />
                  )}
                </>
              )}
            </Tab>
          );
        })}
      </TabList>
    </>
  );
};

export default HistoryTabNavigation;
